import React from "react";
import {styled} from "@mui/material/styles";
import {Grid, Tab as MUITab, Tabs as MUITabs, Typography as MUITypography} from "@mui/material";

const Tabs = styled(MUITabs)(({theme}) => ({
  minHeight: "32px",
  [`& .MuiTabs-indicator`]: {
    backgroundColor: theme.palette.primary
  }
}))

const Tab = styled(MUITab)(() => ({
  minHeight: "32px",
  padding: "4px 12px"
}))

const Panel = styled(Grid)(() => ({
  padding: "0 1rem"
}))

const Content = styled(Grid)(() => ({
  boxShadow: "0px 0px 0px 1px rgb(219 222 223 / 44%)",
  gap: "20px",
  width: "100%",
  display: "grid",
  padding: "20px",
  background: "white",
  alignItems: "center",
  minHeight: "72px",
  minWidth: "calc(100vw - 272px)"
}))

const Typography = styled(MUITypography)(() => ({
  fontSize: "18px",
  fontWeight: "600",
  fontStyle: "normal",
  fontFamily: "Open Sans",
}))

type Props = {
  title?: string | JSX.Element,
  tab?: { value: number, onChange: (event: React.SyntheticEvent, value: number) => void, tabs: Array<{ label: string, value: number, disabled?: boolean }> },
  actions?: Array<JSX.Element>
}

export default function Title(props: Props): JSX.Element | null {
  const {title, tab, actions} = props

  return (
    <Content>
      <Grid container direction="row" alignItems="center" justifyContent="space-between">
        <Grid item>
          <Grid container direction="row" alignItems="center" justifyContent="stretch">
            {title ? (
              <Grid item>
                <Typography>{title}</Typography>
              </Grid>
            ) : null}
            <Panel>
              {tab ? (
                <Tabs value={tab.value} onChange={tab.onChange}>
                  {tab.tabs.map((item, index) => <Tab key={index} label={item.label} disabled={item.disabled} value={item.value} />)}
                </Tabs>
              ) : null}
            </Panel>
          </Grid>
        </Grid>
        <Grid item>
          <Grid container direction="row" alignItems="center" justifyContent="end" spacing={2}>
            {actions?.map((action, index) => (
              <Grid key={index} item>
                {action}
              </Grid>
            ))}
          </Grid>
        </Grid>
      </Grid>
    </Content>
  )
}